import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import useGlobal from '../../store';


const SuggestedRow = (props) => {

    const [isSaving, setIsSaving] = useState(false);

    const [response, userActions] = useGlobal(
        state => state.response,
        actions => actions.userActions
    );

    const buildAvatarUrl = (userData) => {
        if(userData.hasOwnProperty('avatarFile') && userData.avatarFile && (userData.avatarFile.indexOf('_avatar') > 0 || userData.avatarFile.length > 30)) {
	        return <img src={"https://weblight.imgix.net/avatars/"+userData.avatarFile + "?w=100&h=100&fit=facearea&faceindex=1&facepad=2"} alt="" />;
	    }
	    // if(userData.FBID && userData.FBID !== "0") {
	    //     return <img src={"https://graph.facebook.com/" + userData.FBID + "/picture?type=large"} alt="" />;
        // }
        return (<div className="kt-media kt-media--lg kt-media--circle kt-media--info">
            <span>{userData.FirstName ? userData.FirstName.charAt(0) : '?'}{userData.LastName ? userData.LastName.charAt(0) : ''}</span>
        </div>);
    }

    const addGiftlist = () => {
        setIsSaving(true);
        let data = { userID : props.giftlist.userID };
        console.log('ADD THIS GIFTLIST', data);
        userActions.addGiftlist(data);
    }

    useEffect(() => {
        if(!response || response.type !== "addgiftlist") {
            return;
        }
        setIsSaving(false);
    }, [response]);

    return (
    <div className="kt-portlet kt-widget kt-widget--general-3 giftlist-row m-0">
        <div className="kt-portlet__body kt-portlet__body--fit">
            <div className="kt-widget__top pt-2 pb-2 pl-2 pr-2">
                <div className="kt-media kt-media--lg kt-media--circle">
                    {buildAvatarUrl(props.giftlist)}
                </div>
                <div className="kt-widget__wrapper">
                    <div className="kt-widget__label">
                        <span className="kt-widget__title">
                            {props.giftlist.FirstName} {props.giftlist.LastName}
                        </span>
                        { props.giftlist.addedBy && props.giftlist.addedBy !== "" ? <div>
                        <span className="kt-widget__desc">
                            Owner: {props.giftlist.addedBy}
                        </span></div> : <></> }
                        
                    </div>
                    
                    
                    <div className="kt-widget__stats">
                        <Button color="primary" onClick={() => addGiftlist()}>
                            { isSaving ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : "ADD" }
                        </Button>
                        
                    </div>
                </div>
            </div>
            
        </div>
    </div>);
}

export default SuggestedRow;
